(() => {
  const searchKey = 'pushpaura:recent-searches';
  const viewedKey = 'pushpaura:recently-viewed';
  const storageGet = (key) => {
    try { return JSON.parse(localStorage.getItem(key) || '[]'); } catch (_) { return []; }
  };
  const storageSet = (key, value) => {
    try { localStorage.setItem(key, JSON.stringify(value)); } catch (_) { /* Storage may be disabled. */ }
  };

  const productHandle = document.querySelector('product-info[data-url]')?.dataset.url?.split('/products/')[1]?.split(/[?#]/)[0];
  if (productHandle) {
    const viewed = storageGet(viewedKey).filter((handle) => handle !== productHandle);
    storageSet(viewedKey, [productHandle, ...viewed].slice(0, 6));
  }

  document.querySelectorAll('.search-modal__form form[role="search"]').forEach((form) => {
    const input = form.querySelector('input[name="q"]');
    const discovery = form.querySelector('[data-search-discovery]');
    if (!input || !discovery) return;

    const searchesSection = discovery.querySelector('[data-recent-searches]');
    const searchesList = discovery.querySelector('[data-recent-search-list]');
    const viewedSection = discovery.querySelector('[data-recently-viewed]');
    const viewedList = discovery.querySelector('[data-recently-viewed-list]');
    const updateDiscoveryVisibility = () => {
      discovery.hidden = input.value.trim().length > 0 || (searchesSection.hidden && viewedSection.hidden);
    };

    const render = () => {
      const searches = storageGet(searchKey);
      searchesList.replaceChildren(...searches.map((query) => {
        const link = document.createElement('a');
        link.className = 'pa-search-discovery__query';
        link.href = `/search?q=${encodeURIComponent(query)}&type=product&options%5Bprefix%5D=last`;
        link.textContent = query;
        return link;
      }));
      searchesSection.hidden = searches.length === 0;

      const handles = storageGet(viewedKey);
      viewedList.replaceChildren();
      viewedSection.hidden = handles.length === 0;
      handles.slice(0, 3).forEach(async (handle) => {
        try {
          const response = await fetch(`/products/${encodeURIComponent(handle)}.js`);
          if (!response.ok) return;
          const product = await response.json();
          const link = document.createElement('a');
          link.className = 'pa-search-discovery__product';
          link.href = `/products/${encodeURIComponent(product.handle)}`;
          if (product.featured_image) {
            const image = document.createElement('img');
            image.src = product.featured_image;
            image.alt = '';
            image.loading = 'lazy';
            link.append(image);
          }
          const title = document.createElement('span');
          title.className = 'pa-search-discovery__product-title';
          title.textContent = product.title;
          link.append(title);
          const price = document.createElement('span');
          price.className = 'pa-search-discovery__product-price';
          const currency = window.Shopify?.currency?.active || 'INR';
          price.textContent = new Intl.NumberFormat(undefined, { style: 'currency', currency }).format((product.price || 0) / 100);
          link.append(price);
          viewedList.append(link);
        } catch (_) {
          // A product may have been removed or become unavailable.
        }
      });
      updateDiscoveryVisibility();
    };

    render();
    input.addEventListener('input', updateDiscoveryVisibility);
    input.addEventListener('focus', updateDiscoveryVisibility);
    form.addEventListener('submit', () => {
      const query = input.value.trim();
      if (!query) return;
      const searches = storageGet(searchKey).filter((item) => item.toLowerCase() !== query.toLowerCase());
      storageSet(searchKey, [query, ...searches].slice(0, 6));
    });
  });
})();
